import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_TITLE = "Repexo Executive Search";
const BASE_URL = "https://www.repexo.de";
const HOME_TITLE = "REPEXO Headhunting: Personalsuche in der Direktansprache";
const MEDICAL_HOME_TITLE = "Medizinstellen besetzen durch Direktansprache";
const SALES_HOME_TITLE = "Headhunter Sales & Vertrieb - vom Profi seit 1981 - REPEXO Sales";
const DEFAULT_DESCRIPTION = "REPEXO Headhunting: Personalsuche in der Direktansprache für Sales und Medical.";

const MEDICAL_ROUTE_TITLES = {
  "/medical": MEDICAL_HOME_TITLE,
  "/medical/insights": "Einblicke im Healthcare-Recruiting | REPEXO Medical",
  "/medical/suchmethode": "Suchmethode & Direktansprache | REPEXO Medical",
  "/medical/executive-search": "Executive Search Medizin | REPEXO Medical",
  "/medical/praxisnachfolger-suche": "Praxisnachfolger-Suche | REPEXO Medical",
  "/medical/referenzen": "Referenzen | REPEXO Medical",
  "/medical/garantien": "Garantien | REPEXO Medical",
  "/medical/soziale-verantwortung": "Soziale Verantwortung | REPEXO Medical",
  "/medical/rekrutierungsprozess": "Rekrutierungsprozess | REPEXO Medical",
  "/medical/faq": "FAQ | REPEXO Medical",
  "/medical/kandidatenreise": "Kandidatenreise | REPEXO Medical",
  "/medical/karriere": "Karriere | REPEXO Medical",
  "/medical/kandidatenfeedback": "Kandidatenfeedback | REPEXO Medical",
  "/medical/faq-kandidaten": "FAQ für Kandidaten | REPEXO Medical",
  "/medical/fallstudien": "Fallstudien | REPEXO Medical",
  "/medical/geschichte": "Geschichte | REPEXO Medical",
  "/medical/team": "Team | REPEXO Medical",
  "/medical/besetzte-positionen": "Besetzte Positionen | REPEXO Medical",
  "/medical/auszeichnungen": "Auszeichnungen | REPEXO Medical",
  "/medical/magazine": "Presse & Magazine | REPEXO Medical",
  "/medical/impressum": "Impressum | REPEXO Medical",
  "/medical/agb": "AGB | REPEXO Medical",
  "/medical/datenschutz": "Datenschutz | REPEXO Medical",
};

const SALES_ROUTE_TITLES = {
  "/sales": SALES_HOME_TITLE,
  "/sales/geschichte": "Geschichte | REPEXO Sales",
  "/sales/team": "Team | REPEXO Sales",
  "/sales/insights": "Einblicke zu Sales & Vertrieb | REPEXO Sales",
  "/sales/referenzen": "Referenzen | REPEXO Sales",
  "/sales/awards": "Auszeichnungen | REPEXO Sales",
  "/sales/magazine": "Presse & Magazine | REPEXO Sales",
  "/sales/sales-klassisch": "Salespersonal klassisch | REPEXO Sales",
  "/sales/sales-industrie": "Industrie Sales hochtechnisch | REPEXO Sales",
  "/sales/sales-healthcare": "Healthcare Sales | REPEXO Sales",
  "/sales/impressum": "Impressum | REPEXO Sales",
  "/sales/agb": "AGB | REPEXO Sales",
  "/sales/datenschutz": "Datenschutz | REPEXO Sales",
};

const MEDICAL_ROUTE_DESCRIPTIONS = {
  "/medical": "REPEXO Medical: Medizinstellen durch Direktansprache und Executive Search erfolgreich besetzen.",
  "/medical/insights": "Fachbeiträge und Einblicke zu Healthcare Recruiting, Direktansprache und Personalberatung.",
  "/medical/suchmethode": "Unsere Suchmethode: Direktansprache und Headhunting für medizinische Fach- und Führungskräfte.",
  "/medical/executive-search": "Executive Search im Healthcare-Bereich für Führungskräfte und Spezialisten.",
  "/medical/praxisnachfolger-suche": "Praxisnachfolger-Suche für Ärzte und Praxisinhaber - diskret und zielgerichtet.",
  "/medical/referenzen": "Referenzen und Erfolgsgeschichten aus der medizinischen Personalberatung von REPEXO.",
  "/medical/garantien": "Unsere Qualitätsgarantien in der Personalberatung für den medizinischen Bereich.",
  "/medical/soziale-verantwortung": "Soziale Verantwortung von REPEXO im Healthcare-Recruiting.",
  "/medical/rekrutierungsprozess": "Unser strukturierter Rekrutierungsprozess von der Analyse bis zur Besetzung.",
  "/medical/faq": "Antworten auf häufige Fragen zur medizinischen Personalberatung bei REPEXO.",
  "/medical/kandidatenreise": "Die Kandidatenreise bei REPEXO: von der Ansprache bis zum Vertragsabschluss.",
  "/medical/karriere": "Karriere bei REPEXO Medical - Einstiegsmöglichkeiten und Perspektiven.",
  "/medical/kandidatenfeedback": "Erfahrungen und Feedback von Kandidaten, die mit REPEXO zusammenarbeiten.",
  "/medical/faq-kandidaten": "Häufige Fragen für Kandidaten im medizinischen Headhunting.",
  "/medical/fallstudien": "Fallstudien aus der Praxis: erfolgreiche Besetzungen im Gesundheitswesen.",
  "/medical/geschichte": "Die Geschichte von REPEXO Medical und unsere Entwicklung im Markt.",
  "/medical/team": "Das Team von REPEXO Medical - Ihre Ansprechpartner in der Personalberatung.",
  "/medical/besetzte-positionen": "Überblick über erfolgreich besetzte Positionen im Healthcare-Bereich.",
  "/medical/auszeichnungen": "Auszeichnungen und Anerkennungen von REPEXO Medical.",
  "/medical/magazine": "Presse und Magazine: Veröffentlichungen über REPEXO Medical.",
  "/medical/impressum": "Impressum von REPEXO Medical.",
  "/medical/agb": "Allgemeine Geschäftsbedingungen von REPEXO Medical.",
  "/medical/datenschutz": "Datenschutzhinweise von REPEXO Medical.",
};

const SALES_ROUTE_DESCRIPTIONS = {
  "/sales": "REPEXO Sales: Headhunter für Vertrieb und Sales-Positionen seit 1981.",
  "/sales/geschichte": "Die Geschichte von REPEXO Sales im Vertriebs-Headhunting.",
  "/sales/team": "Das Team von REPEXO Sales - erfahrene Berater für Vertrieb und Verkauf.",
  "/sales/insights": "Einblicke zu Vertrieb, Recruiting und Sales-Headhunting.",
  "/sales/referenzen": "Referenzen und Erfolge von REPEXO Sales im Vertrieb.",
  "/sales/awards": "Auszeichnungen und Anerkennungen von REPEXO Sales.",
  "/sales/magazine": "Presse und Magazine: Veröffentlichungen über REPEXO Sales.",
  "/sales/sales-klassisch": "REPEXO Salespersonal klassisch - Headhunting für Vertriebsteams.",
  "/sales/sales-industrie": "REPEXO Industrie Sales hochtechnisch - Vertrieb für technische Märkte.",
  "/sales/sales-healthcare": "REPEXO Healthcare Sales - Vertriebsspezialisten für Pharma und Medizintechnik.",
  "/sales/impressum": "Impressum von REPEXO Sales.",
  "/sales/agb": "Allgemeine Geschäftsbedingungen von REPEXO Sales.",
  "/sales/datenschutz": "Datenschutzhinweise von REPEXO Sales.",
};

const INSIGHT_SLUG_TITLES = {
  "chefarzt-rekrutierung": "Fachkräftemangel im Gesundheitswesen und seine Lösungen",
  "direktansprache": "Warum Direktansprache im Healthcare Recruiting wichtig ist",
  "trends-2026": "Recruiting Trends im Healthcare Markt 2026",
  "digital-future": "Die digitale Zukunft im Gesundheitswesen",
  "ai-recruitment": "KI in der medizinischen Personalgewinnung",
  "direct-patient": "Direct-to-Patient Zukunft im Gesundheitswesen",
  "cost-leadership": "Kostenmanagement in der Rekrutierung von Klinikführungskräften",
  "nachfolgeplanung": "Nachfolgeplanung in Kliniken: Best Practices",
};

function getInsightTitle(path) {
  const medicalPrefix = "/medical/insights/";
  const salesPrefix = "/sales/insights/";

  if (path.startsWith(medicalPrefix)) {
    const slug = path.slice(medicalPrefix.length);
    if (!slug) return null;
    return `${INSIGHT_SLUG_TITLES[slug] || "Einblick"} | REPEXO Medical`;
  }

  if (path.startsWith(salesPrefix)) {
    const slug = path.slice(salesPrefix.length);
    if (!slug) return null;
    return `${INSIGHT_SLUG_TITLES[slug] || "Einblick"} | REPEXO Sales`;
  }

  return null;
}

function getInsightDescription(path) {
  const medicalPrefix = "/medical/insights/";
  const salesPrefix = "/sales/insights/";
  if (path.startsWith(medicalPrefix)) {
    return "Detailansicht eines Fachbeitrags von REPEXO Medical zu Recruiting, Direktansprache und Executive Search.";
  }
  if (path.startsWith(salesPrefix)) {
    return "Detailansicht eines Fachbeitrags von REPEXO Sales zu Vertrieb, Recruiting und Headhunting.";
  }
  return null;
}

function ensureMetaDescriptionTag() {
  let tag = document.querySelector('meta[name="description"]');
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", "description");
    document.head.appendChild(tag);
  }
  return tag;
}

function ensureCanonicalTag() {
  let tag = document.querySelector('link[rel="canonical"]');
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", "canonical");
    document.head.appendChild(tag);
  }
  return tag;
}

export default function usePageTitle() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname || "/";
    const metaDescription = ensureMetaDescriptionTag();
    const canonical = ensureCanonicalTag();
    canonical.setAttribute("href", `${BASE_URL}${path === "/" ? "/" : path}`);

    if (path === "/") {
      document.title = HOME_TITLE;
      metaDescription.setAttribute(
        "content",
        "REPEXO Headhunting: Personalsuche in der Direktansprache für Sales und Medical."
      );
      return;
    }

    const insightTitle = getInsightTitle(path);
    const insightDescription = getInsightDescription(path);
    if (insightTitle) {
      document.title = insightTitle;
      metaDescription.setAttribute("content", insightDescription || DEFAULT_DESCRIPTION);
      return;
    }

    if (MEDICAL_ROUTE_TITLES[path]) {
      document.title = MEDICAL_ROUTE_TITLES[path];
      metaDescription.setAttribute(
        "content",
        MEDICAL_ROUTE_DESCRIPTIONS[path] || DEFAULT_DESCRIPTION
      );
      return;
    }

    if (SALES_ROUTE_TITLES[path]) {
      document.title = SALES_ROUTE_TITLES[path];
      metaDescription.setAttribute(
        "content",
        SALES_ROUTE_DESCRIPTIONS[path] || DEFAULT_DESCRIPTION
      );
      return;
    }

    document.title = BASE_TITLE;
    metaDescription.setAttribute("content", DEFAULT_DESCRIPTION);
  }, [location.pathname]);
}

